import React from 'react';
import { motion } from 'framer-motion';

const BookCover = () => {
  return (
    <div className="relative w-64 h-96 md:w-80 md:h-[500px] perspective-1000 mx-auto">
      <motion.div 
        initial={{ rotateY: -30, rotateX: 10 }}
        animate={{ rotateY: -15, rotateX: 5 }}
        transition={{ 
          duration: 5, 
          repeat: Infinity, 
          repeatType: "reverse", 
          ease: "easeInOut" 
        }}
        className="relative w-full h-full transform-style-3d shadow-2xl"
      >
        {/* Front Cover */}
        <div className="absolute inset-0 bg-brand-black border-4 border-brand-yellow flex flex-col items-center justify-between p-8 text-center backface-hidden z-20 rounded-r-sm shadow-xl">
          <div className="text-brand-yellow font-bold tracking-widest text-sm uppercase">The Translation Table</div>
          
          <div className="flex flex-col gap-4">
            <h1 className="text-4xl md:text-5xl font-extrabold text-white leading-tight">
              100<br/>
              <span className="text-brand-yellow">RELATIONSHIP</span><br/>
              PHRASES<br/>
              DECODED
            </h1>
          </div>

          <div className="w-full">
            <div className="h-0.5 bg-brand-yellow w-1/3 mx-auto mb-4"></div>
            <p className="text-white text-sm font-medium">Stop Guessing.<br/>Start Understanding.</p>
          </div>
        </div>

        {/* Spine */}
        <div className="absolute top-0 bottom-0 left-0 w-12 bg-brand-yellow transform -translate-x-full origin-right rotate-y-90 flex items-center justify-center">
           <span className="transform rotate-90 text-brand-black font-bold tracking-widest whitespace-nowrap">THE TRANSLATION TABLE</span>
        </div>

        {/* Pages (Thickness) */}
        <div className="absolute top-2 bottom-2 right-0 w-12 bg-white transform translate-z-[-2px] -translate-x-1"></div>
        <div className="absolute top-2 bottom-2 right-0 w-10 bg-gray-200 transform translate-z-[-4px] -translate-x-2"></div>
        <div className="absolute top-2 bottom-2 right-0 w-8 bg-gray-300 transform translate-z-[-6px] -translate-x-3"></div>

        {/* Back Cover (creating depth) */}
        <div className="absolute inset-0 bg-brand-black transform translate-z-[-20px] rounded-l-sm"></div>
      </motion.div>
      
      {/* Shadow */}
      <div className="absolute -bottom-10 left-10 right-10 h-8 bg-black/50 blur-xl rounded-[100%]"></div>
    </div>
  );
};

export default BookCover;